import { updateOperatorRole } from './admin/update-operator-role';

export const userApi = {
    admin: {
        updateOperatorRole,
    },
};
